import { useDialogActions } from '@/stores'
import { SupportTicketDialog } from '../components'
import {
  SCREENING_ALLOWANCE_TICKET_PREFILL,
  UPGRADE_TICKET_PREFILL,
} from '../prefill'

export const useSupportTicket = () => {
  const { openDialog } = useDialogActions()

  return {
    openTicket: () => openDialog(SupportTicketDialog.id),
    openUpgradeTicket: () =>
      openDialog(SupportTicketDialog.id, UPGRADE_TICKET_PREFILL),
    openScreeningAllowanceTicket: () =>
      openDialog(SupportTicketDialog.id, SCREENING_ALLOWANCE_TICKET_PREFILL),
  }
}
